export default {
  // GET Requests //

  // Gets all challenges
  async getChallengesData(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let challenges;
    let submissions;
    try {
      challenges = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/challenges/retrieve-all-by-company/" +
          companyId +
          "/all/false",
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      challenges = await challenges.json();

      submissions = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/challenge-submission/retrieve-all-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      submissions = await submissions.json();
    } catch (err) {
      return 500;
    }

    context.commit("challenges", challenges.challenges);
    context.commit("submissions", submissions.submissions);
    context.commit("challengesLoaded");

    return 200;
  },
  // POST Requests //

  // Add new challenge
  async postChallenge(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenges/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: context.rootGetters["userData/companyId"],
            published: true,
            title: payload.title,
            description: payload.description,
            requirements: payload.requirements,
            primaryLanguage: context.rootGetters["userData/selectedCulture"],
            challengeType: payload.challengeType,
            submissionType: payload.submissionType,
            audience: payload.audience,
            departments: payload.departments,
            locations: payload.locations,
            points: payload.points || 0,
            participationPoints: payload.participationPoints,
            startDate: payload.startDate,
            endDate: payload.endDate,
            fullName: payload.fullName,
            companyRole: payload.companyRole,
            emailAddress: payload.emailAddress,
            phoneNumber: payload.phoneNumber,
            userId: context.rootGetters["userData/userId"],
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    console.log(response);
    var challengesPayload = context.state.challenges;

    challengesPayload.push(response.challenge);

    context.commit("challenges", challengesPayload);

    return {
      status: 201,
      challengeId: response.challenge.challengeId,
      title: response.challenge.title,
    };
  },

  // Add submissions to challenge
  async postAddSubmissionsToChallenge(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;
    var submissionsPayload = context.state.submissions;
    try {
      let submissionIds = [];

      let submission;
      for (let i = 0; i < payload.userIds.length; i++) {
        submission = await fetch(
          process.env.VUE_APP_NODE_SERVER + "/challenge-submission/add",
          {
            method: "POST",
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              userId: payload.userIds[i],
              challengeId: payload.challengeId,
              submissionType: "none",
              companyId: companyId,
            }),
          }
        );
        submission = await submission.json();
        submissionIds.push(submission.submission.submissionId);
        submissionsPayload.push(submission.submission);
      }

      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenges/add-submissions",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            challengeId: payload.challengeId,
            submissionIds: submissionIds,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    var challengesPayload = context.state.challenges;
    for (let i = 0; i < challengesPayload.length; i++) {
      if (challengesPayload[i].challengeId == response.challenge.challengeId) {
        challengesPayload[i] = response.challenge;
        break;
      }
    }
    context.commit("challenges", challengesPayload);

    context.commit("submissions", submissionsPayload);

    return 201;
  },
  // Create a challenge image submission
  async postImageChallenge(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    let submission;
    let response;

    try {
      let attachments = [];
      for (let i = 0; i < payload.attachments.length; i++) {
        var fd = new FormData();
        fd.append("file", payload.attachments[i]);
        fd.append("fileType", payload.attachments[i].type);
        fd.append("userId", userId);

        response = await fetch(
          process.env.VUE_APP_NODE_SERVER +
            "/challenge-submission/upload-image",
          {
            method: "POST",
            mode: "cors",
            headers: {
              Authorization: "Bearer " + token,
            },
            body: fd,
          }
        );

        response = await response.json();

        attachments.push({
          source: response.source,
          type: response.fileType,
          size: response.size,
        });
      }

      submission = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenge-submission/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            userId: userId,
            companyId: companyId,
            challengeId: payload.challengeId,
            submissionType: "image",
            attachments: attachments,
          }),
        }
      );

      submission = await submission.json();
    } catch (err) {
      return { status: 500 };
    }

    let submissionPayload = context.state.submissions;
    submissionPayload.push(submission.submission);
    context.commit("submissions", submissionPayload);

    return {
      status: 201,
      submissionId: submission.submission.submissionId,
    };
  },
  // Create a challenge video submission
  async postVideoChallenge(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    const userId = context.rootGetters["userData/userId"];
    let submission;
    let session;
    var attachments = [];

    // Video Settings
    const chunkSize = 6000000;
    let totalChunks;
    let fileName;
    var uploadedPromises = [];
    let start = 0;
    let end;
    let uploadId;
    let chunk;
    let fd;

    try {
      for (let i = 0; i < payload.attachments.length; i++) {
        // Upload video
        fileName =
          payload.challengeId +
          "_" +
          userId +
          "_" +
          i +
          "." +
          payload.attachments[i].type.substring(
            payload.attachments[i].type.lastIndexOf("/") + 1
          );
        totalChunks = Math.ceil(
          Number(payload.attachments[i].size) / chunkSize
        );

        session = await fetch(
          process.env.VUE_APP_NODE_SERVER +
            "/challenge-submission/initiate-video-upload",
          {
            method: "POST",
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              fileName: fileName,
            }),
          }
        );
        session = await session.json();
        uploadId = session.uploadId;

        start = 0;
        end = null;

        uploadedPromises = [];
        for (let j = 0; j < totalChunks; j++) {
          end = start + chunkSize;
          chunk = payload.attachments[i].slice(start, end);
          fd = new FormData();
          fd.append("file", chunk);
          fd.append("fileName", fileName);
          fd.append("index", j);
          fd.append("uploadId", uploadId);

          session = await fetch(
            process.env.VUE_APP_NODE_SERVER +
              "/challenge-submission/upload-video-chunk",
            {
              method: "POST",
              mode: "cors",
              headers: {
                Authorization: "Bearer " + token,
              },
              body: fd,
            }
          );
          session = await session.json();
          uploadedPromises.push(session);
          start = end;
        }

        session = await fetch(
          process.env.VUE_APP_NODE_SERVER +
            "/challenge-submission/upload-video-complete",
          {
            method: "POST",
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              fileName: fileName,
              uploadId: uploadId,
            }),
          }
        );
        session = await session.json();

        attachments.push({
          source: session.source,
          size: payload.attachments[i].size,
          type:
            "video/" +
            payload.attachments[i].type.substring(
              payload.attachments[i].type.lastIndexOf("/") + 1
            ),
        });
      }

      submission = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenge-submission/add",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            userId: userId,
            companyId: companyId,
            challengeId: payload.challengeId,
            submissionType: "video",
            attachments: attachments,
          }),
        }
      );

      submission = await submission.json();
    } catch (err) {
      return { status: 500 };
    }

    let submissionPayload = context.state.submissions;
    submissionPayload.push(submission.submission);
    context.commit("submissions", submissionPayload);

    return {
      status: 201,
      submissionId: submission.submissionId,
    };
  },

  // PATCH Requests //

  // update a challenge
  async patchChallenge(context, payload) {
    const token = context.rootGetters["authData/token"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenges/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: context.rootGetters["userData/companyId"],
            userId: context.rootGetters["userData/userId"],
            challengeId: payload.challengeId,
            challengeType: payload.challengeType,
            title: payload.title,
            description: payload.description,
            requirements: payload.requirements,
            audience: payload.audience,
            departments: payload.departments,
            locations: payload.locations,
            points: payload.points,
            participationPoints: payload.participationPoints,
            endDate: payload.endDate,
            startDate: payload.endDate ? payload.startDate : null,
            fullName: payload.fullName,
            companyRole: payload.companyRole,
            emailAddress: payload.emailAddress,
            phoneNumber: payload.phoneNumber,
            status: payload.status,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }
    var challengesPayload = context.state.challenges;

    for (let i = 0; i < challengesPayload.length; i++) {
      if (challengesPayload[i].challengeId == response.challenge.challengeId) {
        challengesPayload[i] = response.challenge;
        break;
      }
    }

    context.commit("challenges", challengesPayload);

    return 200;
  },

  // Add submission ids to challenge
  async patchAddSubmissionToChallenge(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenges/add-submissions",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            challengeId: payload.challengeId,
            submissionIds: payload.submissionIds,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }
    var challengesPayload = context.state.challenges;

    for (let i = 0; i < challengesPayload.length; i++) {
      if (challengesPayload[i].challengeId == response.challenge.challengeId) {
        challengesPayload[i] = response.challenge;
        break;
      }
    }

    context.commit("challenges", challengesPayload);

    return 200;
  },
  // Adds challenge image
  async patchChallengeImage(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fd = new FormData();
    fd.append("file", payload.file, payload.challengeId);
    fd.append("challengeId", payload.challengeId);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/challenges/update-challenge-image",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }

    var challengesPayload = context.state.challenges;

    for (let i = 0; i < challengesPayload.length; i++) {
      if (challengesPayload[i].challengeId == session.challenge.challengeId) {
        challengesPayload[i] = session.challenge;
        break;
      }
    }

    context.commit("challenges", challengesPayload);

    session.status = 200;
    return session;
  },
  // Reset timestamp
  challengesTimestampReset(context) {
    context.commit("challengesTimestampReset");
  },
};
